/* eslint-disable no-console */

import { register } from 'register-service-worker'

//if (process.env.NODE_ENV === 'production') {
  register(`${process.env.BASE_URL}service-worker.js`, {
    ready () {
      console.log(
        'App is being served from cache by a service worker.\n' +
        'For more details, visit https://goo.gl/AFskqB'
      )
    },
    registered (registration) {
      console.log('Service worker has been registered.')
      // On Dev, proactively check for the latest deployed build.
      // Production keeps the existing user-confirmed update banner.
      if (window.location.hostname === 'justicestory-dev.azurewebsites.net') {
        registration.update().catch(error => console.warn('SW update check failed', error))
        window.addEventListener('focus', () => {
          registration.update().catch(error => console.warn('SW update check failed', error))
        })
      }
    },
    cached () {
      console.log('Content has been cached for offline use.')
    },
    updatefound () {
      console.log('New content is downloading.')
    },
    updated (registration) {
      console.log('New content is available, sending custom event')
      if (window.location.hostname === 'justicestory-dev.azurewebsites.net' && registration.waiting) {
        // Keep Dev fresh automatically; production still asks before updating.
        registration.waiting.postMessage({ type: 'SKIP_WAITING' })
        return
      }

      document.dispatchEvent(
        new CustomEvent('swUpdated', { detail: registration })
      )

      //let confirmationResult = confirm("This application has been updated. Do you want to reload the app?")
      //if (confirmationResult)
      //  registration.waiting.postMessage({action: "skipWaiting"})
    },
    offline () {
      console.log('No internet connection found. App is running in offline mode.')
    },
    error (error) {
      console.error('Error during service worker registration:', error)
    }
  })


  let refreshing
  navigator.serviceWorker.addEventListener("controllerchange", e=>{
    if (refreshing) return
    window.location.reload()
    refreshing = true
  })

//}